export class TextUtils {
    static BuildNameWithSuffix(name, suffix, separator) {
        return `${name}${separator ?? TextUtils.DEFAULT_SEPARATOR}${suffix}`;
    }
    static GetUriExtension(uri) {
        const lastDot = uri.lastIndexOf(".");
        return lastDot !== -1 ? uri.substring(lastDot + 1) : null;
    }
}
TextUtils.DEFAULT_SEPARATOR = ".";
//# sourceMappingURL=text.js.map